import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { Edit, PlusCircle } from "feather-icons-react/build/IconComponents";
import Error404 from "MainPages/ErrorPages/error404";
import AllowanceFrom from "Components/Modal/allowance";
import { useForm, FormProvider } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import ToastNotification from "Components/UI/ToastNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import {
  useAddAdditionMutation,
  useDeletePayrollAdditionMutation,
  useUpdateAdditionMutation,
} from "AppQuries/payroll/addition/addition";
import { additionValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { Trash2 } from "react-feather";
import { Popconfirm, Switch } from "antd";
import { toast } from "core/Operations/toast";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";

const AllowanceList = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const methods = useForm({
    resolver: yupResolver(additionValidationSchema),
  });
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: GetAllowances,
  } = useGetAdditionsQuery({
    companyCode: userData?.companyCode,
    isTrue: showActiveOnly,
  });
  const { mutate: addAllowance } = useAddAdditionMutation();
  const { mutate: updateAllowance } = useUpdateAdditionMutation();
  const { mutate: deleteItem } = useDeletePayrollAdditionMutation();
  const [selectedAllowance, setSelectedAllowance] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const allowanceData = data?.data.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const { setSearchValue, filteredData } = useTableSearch(allowanceData, [
    "description",
    "haveCpf",
    "isTaxPayable",
  ]);

  const handleAddClick = () => {
    setSelectedAllowance(null);
    methods.reset({
      companyCode: userData.companyCode,
      description: "",
      haveCpf: true,
      isTaxPayable: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (allowance) => {
    setSelectedAllowance(allowance);
    methods.reset({
      companyCode: allowance.companyCode,
      description: allowance.description,
      haveCpf: allowance.haveCpf,
      isTaxPayable: allowance.isTaxPayable,
      createUser: allowance.createUser,
      createDate: allowance.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    if (selectedAllowance) {
      payload.code = selectedAllowance.code;
      updateAllowance(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Allowance Updated Successfully.");

            setSelectedAllowance(null);
            setShow(false);
            GetAllowances();
          } else {
            toast.warning("Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      payload.code = 0;
      addAllowance(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Allowance Added Successfully.");

            setShow(false);
            GetAllowances();
          } else {
            toast.warning(error.message || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully.");

          setShow(false);
          GetAllowances();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    if (isMount) GetAllowances();
    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  const columns = [
    {
      title: "SNo",
      dataIndex: "id",
    },
    {
      title: "Allowance Name",
      dataIndex: "description",
    },
    // {
    //   title: "Have CPF",
    //   dataIndex: "haveCpf",
    //   render: (text, record) => (
    //     <span
    //       className={`badges ${
    //         record.haveCpf ? "bg-lightgreen" : "bg-lightred"
    //       }`}
    //     >
    //       {record.haveCpf ? "Yes" : "No"}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Tax Payable",
    //   dataIndex: "isTaxPayable",
    //   render: (text, record) => (
    //     <span
    //       className={`badges ${
    //         record.isTaxPayable ? "bg-lightgreen" : "bg-lightred"
    //       }`}
    //     >
    //       {record.isTaxPayable ? "Yes" : "No"}
    //     </span>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.payroll_management}
            accessCode={accessCodes.payroll_allowance}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.payroll_management}
            accessCode={accessCodes.payroll_allowance}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.code)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Allowances</h4>
                <h6>Manage your Allowances</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Allowance Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetAllowances}
              />
            </div>
            <div className="page-btn">
              <Can
                accessModule={accessCodes.payroll_management}
                accessCode={accessCodes.payroll_allowance}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Allowance</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add New Allowance
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) =>
                                  setShowActiveOnly(checked)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <AllowanceFrom
          mode={selectedAllowance ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </div>
  );
};

export default AllowanceList;
